import React, { FC, useEffect, useRef } from 'react';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { Alignment, EditorialColumnsProps, ModuleType } from '../../types';
import { LegalInfo } from './LegalInfo';
import { LegalInfoContainer, EditorialColumnsContainer } from './EditorialColumns.style';
import { TextMode as TextModeComponent } from './TextMode';
import { NumbersMode as NumbersModeComponent } from './NumbersMode';
import { ButtonLabels, LinkElement, useTracking } from '../hooks/useTracking';
import { FA_LOCATOR_ID } from '../utils/utils';
import { getThemeName } from '../utils/alpha-helper';
import { darkTheme, lightTheme } from '../theme';

export const EditorialColumns: FC<EditorialColumnsProps> = (props) => {
  const { headingOption, caeIdentifier, disclaimers, components, type, textAlignment, theme } =
    props;

  const hasLegalInfo = !!caeIdentifier || !!disclaimers?.length;
  let flexibleWidth = false;
  let alignmentNumbers: Alignment = Alignment.CENTER;

  if (type === ModuleType.NUMBERS) {
    const { flexibleWidth: fw, alignmentNumbers: an } = props;
    flexibleWidth = fw;
    alignmentNumbers = an;
  }

  const ref = useRef(null);

  const tracking = useTracking(
    {
      implementer: 2,
    },
    ref,
    // type,
  );

  useEffect(() => {
    tracking.sendReadyEvent();
    const getTrackingCtaInfo = () => {
      if (type === ModuleType.NUMBERS) return;
      const labels = components?.flat().filter((column) => column.cta && column.cta.label);
      const buttonLabelList: ButtonLabels | null = labels.length
        ? labels.map((item, index) => ({
            number: index + 1,
            linkElement:
              item.cta?.variant === 'secondary' ? ('cta' as LinkElement) : ('link' as LinkElement),
            label: item.cta?.label || '',
          }))
        : null;
      tracking.registerImpressionTracking(headingOption?.heading, buttonLabelList);
    };
    getTrackingCtaInfo();
  }, []);

  return (
    <ThemeProvider theme={getThemeName(theme === 'Light' ? lightTheme : darkTheme)}>
      <EditorialColumnsContainer data-test-id={FA_LOCATOR_ID} ref={ref}>
        {type === ModuleType.TEXT && components && (
          <TextModeComponent
            components={components}
            headingOption={headingOption}
            textAlignment={textAlignment}
          />
        )}
        {type === ModuleType.NUMBERS && components && (
          <NumbersModeComponent
            components={components}
            headingOption={headingOption}
            alignmentNumbers={alignmentNumbers}
            textAlignment={textAlignment}
            flexibleWidth={flexibleWidth}
          />
        )}

        {hasLegalInfo && (
          <LegalInfoContainer
            data-testid="editorial-colmuns-legal-info-container"
            textAlignment={textAlignment}
          >
            <LegalInfo consumptionAndEmissions={caeIdentifier} disclaimers={disclaimers} />
          </LegalInfoContainer>
        )}
      </EditorialColumnsContainer>
    </ThemeProvider>
  );
};
